import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {ClientsService} from "../models/clients/clients.service";

@Injectable()
export class BadgesHelper {
    constructor(
        private http: Http,
        private clientsService: ClientsService
    ) {}

    public refreshEntity(badgesObject, dataTable) {
        if (badgesObject && badgesObject.data.client_id)
            this.clientsService.getOne(badgesObject.data.client_id).subscribe((res)=> {

                for (let i = 0; i < dataTable.entities.length; i++) {
                    if (dataTable.entities[i].id === res.data.id) {
                        dataTable.entities[i] = res.data;
                        return false;
                    }
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/BadgesHelper.ts